/**
 * 路由路径的唯一来源。
 *
 * 为什么单独一个文件：注册表（`registry.ts`）要给每个游戏卡片生成跳转地址，
 * 路由表（`router.tsx`）要声明真正的路由。两者必须来自同一份常量，
 * 否则会出现「卡片链接指向 /fog-chess、路由却只声明 /fogchess」这类
 * 各自自洽、拼起来 404 的集成缺陷（本项目就踩过一次）。
 */
export const FOG_CHESS_PATH = '/fogchess'

/** 已声明的游戏路由；`registry.spec.ts` 会断言每个注册游戏的 path 都在这里 */
export const ROUTE_PATHS: readonly string[] = [FOG_CHESS_PATH]
